const FieldContato = ({Nome, Link,Valor}) => {
    return <p className="text-lg text-gray-700 mb-4">
        <strong>{Nome}:</strong> <a href={Link} target="_blank" rel="noopener noreferrer" className="text-blue-600 hover:underline">{Valor}</a>
    </p>
}

export default FieldContato